import { Component, Optional } from '@angular/core'
import { IcosCascader } from './cascader'
import { dropAnimation } from '../shared/animation'

@Component({
  selector: 'icos-cascader-menu',
  template: `
    <div class="icos-cascader-menus"
      style="z-index: 2007; position: absolute; top: 100%; left: 0;"
      [@dropAnimation]="root.menuVisible"
      (click)="clickHandle($event)">
      <ul class="icos-cascader-menu" *ngFor="let menuItem of root.steps; let step = index">
        <li *ngFor="let listItem of menuItem; let i = index"
          class="icos-cascader-menu__item"
          [class.icos-cascader-menu__item--extensible]="listItem.children"
          [class.is-active]="listItem.active"
          [class.is-disabled]="listItem.icosDisabled"
          (click)="root.selectHandle($event, step, i)">
          {{listItem.label}}
        </li>
      </ul>
    </div>
  `,
  animations: [dropAnimation],
})
export class IcosCascaderMenu {

  constructor(
    @Optional() public root: IcosCascader,
  ) {
  }

  clickHandle(event: Event): void {
    event.stopPropagation()
  }
}
